import React, {Component} from 'react';
import {Col,Form, FormGroup, ControlLabel} from "react-bootstrap";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import moment from 'moment'
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";

export default class RozliczenieKursySearchform extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd:moment(),
            dataDo:moment(),
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    onChangeDataOd(e){
        this.setState({dataOd:e})
    }

    onChangeDataDo(e){
        this.setState({dataDo:e})
    }

    onClickSzukaj(){
        if(Boolean(this.state.dataOd) && Boolean(this.state.dataDo)){
            let dod = DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd)
            let ddo = DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo)

            if(dod<=ddo){
                this.props.handleClickSzukaj(dod,ddo)
            }
        }
    }

    render() {

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col xs={2}>
                            <ControlLabel>Data od</ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>Data do</ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction btnColor={'primary'} iconType={'fa fa-search'} text={'Szukaj'} onClick={this.onClickSzukaj}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RozliczenieKursow/components/RozliczenieKursySearchform.js